import axios from 'axios';

import { LoadingService } from '../AppLoading';

import { ToastService } from '../AppToast';
import { translateError } from '../shared/language';

import { AppStorage } from './UserStorage';
import { addLocalizationHeader } from './requestHeaders';

const _axios = axios.create({
  baseURL: '/',
});

_axios.interceptors.request.use(function (config) {
  addLocalizationHeader(config);
  if (config.url !== "app/petrolog/print-payment-log") {
    LoadingService.start();
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
_axios.interceptors.response.use(async (response) => {
  LoadingService.stop();

  if (response?.status === 302) {
    const originalRequest: any = response.config;
    if (originalRequest._retried) {
      window.location.hash = '/login';
    } else {
      try {
        await _axios.post(`account/login`, { userNameOrEmailAddress: AppStorage.get('UserName'), password: AppStorage.get('Pass'), rememberMe: false });

        originalRequest._retried = true;
        return _axios(originalRequest);
      } catch (e) {
        window.location.hash = '/login';
      }
    }
  }
  return response;
}, async (error) => {
  LoadingService.stop();
  if (error?.response?.status === 0 || error?.response?.status === 302 || error?.response?.status === 401) {
    const originalRequest = error.config;
    if (originalRequest._retried) {
      window.location.hash = '/login';
    } else {
      try {
        await _axios.post(`account/login`, { userNameOrEmailAddress: AppStorage.get('UserName'), password: AppStorage.get('Pass'), rememberMe: false });

        originalRequest._retried = true;
        return _axios(originalRequest);
      } catch (e) {
        window.location.hash = '/login';
      }
    }
  }
  let show = true;
  if (error && error.config && error.config.url === 'account/logout') {
    show = false;
  }
  if (show) {
    showError(error);
  }

  return Promise.reject(error);
});


const showError = ({ response }) => {
  if (response) {
    ToastService.error(translateError(response));
  }
}

export default _axios;
